// extracted by mini-css-extract-plugin
module.exports = {"box":"_93444fe79c--box--yjfaH","round-icon":"_93444fe79c--round-icon--3Rx-3","box-header":"_93444fe79c--box-header--1xoYO","box-description":"_93444fe79c--box-description--1ZTpl"};